var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useCompanyStore } from "../../../application/stores/company.store";
import { completeServiceFormFilling } from "../../../application/usecases/completeServiceFormFilling";
import { getQuestionnaireByServiceIdAndType } from "../../../application/usecases/getQuestionnaire";
import Loader from "../../../components/common/Loaders/Loader";
import { StepperNavigation } from "../../../components/common/Stepper/StepperNavigation";
import { FormStatus } from "../../../contexts/FormProgressContext";
import { useFormTranslator } from "../../../hooks/useFormTranslations";
import { FormEvaluatorService } from "../../../infrastructure/services";
import { DocumentStatus } from "../../../types/DocumentationTypes";
import { log } from "../../../utils/logger";
import MessageBanner from "../../common/MessageBanner/MessageBanner";
import { OperativeTemplate } from "../../common/Templates/OperativeTemplate";
import LoopIcon from '@mui/icons-material/Loop';
export const DocumentGenerationPage = () => {
    const { serviceFormFillingId } = useParams();
    const idNumerico = Number(serviceFormFillingId);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const { setFormProgressStatus, setDocumentGenerationStatus, company } = useCompanyStore();
    const [sectionsState, setSectionsState] = useState([]);
    const [activeSectionId, setActiveSectionId] = useState();
    const evaluator = new FormEvaluatorService();
    const translator = useFormTranslator();
    const context = useMemo(() => ({
        activityId: company.activityId,
        employees: company.employees
    }), [company.activityId, company.employees]);
    useEffect(() => {
        //Lo lanzo como hilo porque no tengo que esperarme a que acabe
        if (company.documentGenerationStatus !== DocumentStatus.GENERATING) {
            completeServiceFormFilling(idNumerico)
                .catch(err => {
                log.error('Error al completar el formulario:', err);
            });
            setFormProgressStatus(FormStatus.COMPLETED);
            setDocumentGenerationStatus(DocumentStatus.GENERATING);
        }
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const { form } = yield getQuestionnaireByServiceIdAndType(1, company, "PDD");
            setSectionsState(form.questionnaire.sections);
            setIsLoading(false);
        }))();
    }, [idNumerico]);
    useEffect(() => {
        if ((company === null || company === void 0 ? void 0 : company.documentGenerationStatus) === DocumentStatus.GENERATED) {
            navigate('/documentation');
        }
    }, [company === null || company === void 0 ? void 0 : company.documentGenerationStatus]);
    useEffect(() => {
        const defaultSection = sectionsState.find(s => s.id === 'documentation_management');
        if (defaultSection) {
            setActiveSectionId(defaultSection.id);
        }
    }, [sectionsState]);
    const visibleSections = useMemo(() => {
        if (!sectionsState)
            return [];
        return sectionsState.filter((sec) => !(sec === null || sec === void 0 ? void 0 : sec.displayConditions) ||
            evaluator.evaluateDisplayConditions(sec.displayConditions, {}, context));
    }, [sectionsState]);
    if (isLoading) {
        return _jsx(Loader, { fullBlack: true });
    }
    return (_jsxs(OperativeTemplate, Object.assign({ title: "PDDForm.GenerateDoc.title" }, { children: [_jsx(StepperNavigation, { sections: visibleSections, activeSectionId: activeSectionId, translator: translator }), _jsxs("div", Object.assign({ className: 'generate-doc' }, { children: [_jsx("div", Object.assign({ className: 'no-ots-to-do' }, { children: _jsxs("div", Object.assign({ className: 'banner-no-ots' }, { children: [_jsx("div", Object.assign({ className: 'check-wrapper' }, { children: _jsx("div", Object.assign({ className: 'check' }, { children: _jsx(LoopIcon, { className: 'check-icon spin' }) })) })), _jsx("h3", { dangerouslySetInnerHTML: { __html: t('PDDForm.GenerateDoc.text1') } })] })) })), _jsx("p", Object.assign({ className: 'paragraph' }, { children: t('PDDForm.GenerateDoc.text2') })), _jsx("p", Object.assign({ className: 'paragraph ' }, { children: t('PDDForm.GenerateDoc.text3') })), _jsx(MessageBanner, Object.assign({ type: "info", cssClass: "generate-doc_banner-info" }, { children: _jsxs(_Fragment, { children: [_jsx("p", Object.assign({ className: 'fw-600' }, { children: t('PDDForm.GenerateDoc.bannerInfo.text1') })), _jsx("p", Object.assign({ className: 'mt-3' }, { children: t('PDDForm.GenerateDoc.bannerInfo.text2') })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: 'mt-1' }, { children: t('PDDForm.GenerateDoc.bannerInfo.list1') })), _jsx("li", Object.assign({ className: 'mt-1' }, { children: t('PDDForm.GenerateDoc.bannerInfo.list2') })), _jsx("li", Object.assign({ className: 'mt-1' }, { children: t('PDDForm.GenerateDoc.bannerInfo.list3') }))] })] }) })), _jsx("div", Object.assign({ className: 'generate-doc_actions' }, { children: _jsx(Button, Object.assign({ size: "small", variant: "contained", onClick: () => navigate('/') }, { children: t('common.btn.goToInit').toUpperCase() })) }))] }))] })));
};
